var map = {
	"./3-D-carving-beginnings-charms/breakdown.png": 86755,
	"./3-D-carving-beginnings-charms/cube.png": 46672,
	"./3-D-carving-beginnings-charms/flatback.png": 80765,
	"./3-D-carving-beginnings-charms/full.png": 6038,
	"./3-D-carving-beginnings-charms/ice-cream-charms.png": 96233,
	"./3-D-carving-beginnings-charms/poster.png": 77472,
	"./3-D-carving-beginnings-charms/softserves.png": 67041,
	"./Bangles/bangles.png": 35447,
	"./Bangles/burr.png": 35061,
	"./Bangles/distance.png": 8664,
	"./Bangles/file.png": 73507,
	"./Bangles/half.png": 56958,
	"./Bangles/inside.png": 67037,
	"./Bangles/outside.png": 5554,
	"./Bangles/pierce.png": 75402,
	"./Bangles/poster.png": 6721,
	"./Bangles/round.png": 54014,
	"./Bangles/side.png": 7155,
	"./Bangles/solid.png": 37222,
	"./Bangles/template.png": 97414,
	"./Bangles/waste.png": 20844,
	"./Easy-measuring/choose.png": 72008,
	"./Easy-measuring/culet.png": 85118,
	"./Easy-measuring/far.png": 43031,
	"./Easy-measuring/line.png": 12667,
	"./Easy-measuring/match.png": 66092,
	"./Easy-measuring/offcentre.png": 11770,
	"./Easy-measuring/pen.png": 86712,
	"./Easy-measuring/perfect.png": 38033,
	"./Easy-measuring/poster.png": 16227,
	"./Easy-measuring/thick.png": 51533,
	"./Easy-measuring/thin.png": 69535,
	"./Easy-measuring/two.png": 96626,
	"./Easy-measuring/whole.png": 53154,
	"./Flowers/choices.png": 21970,
	"./Flowers/different.png": 40057,
	"./Flowers/flowers.png": 59970,
	"./Flowers/mark.png": 51553,
	"./Flowers/paper.png": 30670,
	"./Flowers/petals.png": 41245,
	"./Flowers/pierce.png": 73399,
	"./Flowers/poster.png": 85818,
	"./Flowers/setting.png": 87601,
	"./Flowers/weight.png": 62045,
	"./Make-bezel-setting-faceted/all.png": 97220,
	"./Make-bezel-setting-faceted/baddaylight.png": 73374,
	"./Make-bezel-setting-faceted/ballburr.png": 78378,
	"./Make-bezel-setting-faceted/daylightfixed.png": 99375,
	"./Make-bezel-setting-faceted/fish.png": 71227,
	"./Make-bezel-setting-faceted/poster.png": 86681,
	"./Make-bezel-setting-faceted/saw.png": 19038,
	"./Make-bezel-setting-faceted/seat.png": 65061,
	"./Make-bezel-setting-faceted/thickness.png": 71438,
	"./Make-bezel-setting-rosecut-and-cabochon/all.png": 55086,
	"./Make-bezel-setting-rosecut-and-cabochon/ananas.png": 62026,
	"./Make-bezel-setting-rosecut-and-cabochon/attach.png": 83515,
	"./Make-bezel-setting-rosecut-and-cabochon/depth.png": 52075,
	"./Make-bezel-setting-rosecut-and-cabochon/outline.png": 63735,
	"./Make-bezel-setting-rosecut-and-cabochon/poster.png": 83138,
	"./Make-bezel-setting-rosecut-and-cabochon/round.png": 22669,
	"./Make-bezel-setting-rosecut-and-cabochon/shape.png": 76103,
	"./Make-bezel-setting-rosecut-and-cabochon/size.png": 97037,
	"./Make-bezel-setting-rosecut-and-cabochon/thickness.png": 51762,
	"./Repeating-pattern-rings/allrings.png": 73192,
	"./Repeating-pattern-rings/entirepattern.png": 45115,
	"./Repeating-pattern-rings/halfpattern.png": 48906,
	"./Repeating-pattern-rings/measuring.png": 19565,
	"./Repeating-pattern-rings/patience.png": 20314,
	"./Repeating-pattern-rings/poster.png": 51291,
	"./Repeating-pattern-rings/ringblank.png": 64391,
	"./Ring-from-separate-parts/ballburr.png": 3877,
	"./Ring-from-separate-parts/catear.png": 4330,
	"./Ring-from-separate-parts/cathedral.png": 54661,
	"./Ring-from-separate-parts/extrawax.png": 69437,
	"./Ring-from-separate-parts/hexagon.png": 43871,
	"./Ring-from-separate-parts/inkypen.png": 80937,
	"./Ring-from-separate-parts/markings.png": 20498,
	"./Ring-from-separate-parts/poster.png": 77311,
	"./Ring-from-separate-parts/rings.png": 29732,
	"./Ring-from-separate-parts/saw.png": 22042,
	"./Signet-rings/curve.png": 80052,
	"./Signet-rings/flat.png": 18064,
	"./Signet-rings/marquise.png": 56959,
	"./Signet-rings/moon.png": 11469,
	"./Signet-rings/octagon.png": 95920,
	"./Signet-rings/poster.png": 54659,
	"./Signet-rings/round.png": 73350,
	"./Signet-rings/signets.png": 42805,
	"./Signet-rings/symmetry.png": 6865,
	"./Signet-rings/taper.png": 24407,
	"./Solitaire-and-fitted-bands/allrings.png": 12899,
	"./Solitaire-and-fitted-bands/fit.png": 19842,
	"./Solitaire-and-fitted-bands/look.png": 65820,
	"./Solitaire-and-fitted-bands/measuring.png": 87343,
	"./Solitaire-and-fitted-bands/poster.png": 69711,
	"./Solitaire-and-fitted-bands/setting.png": 56857,
	"./Solitaire-and-fitted-bands/shape.png": 93982,
	"./Solitaire-and-fitted-bands/stonefit.png": 40319,
	"./Solitaire-and-fitted-bands/sunburst.png": 60009,
	"./Solitaire-and-fitted-bands/wishbone.png": 16493,
	"./Use-heating-pen/added.png": 65107,
	"./Use-heating-pen/alcohollamp.png": 38948,
	"./Use-heating-pen/dentastar.png": 3271,
	"./Use-heating-pen/filed.png": 60590,
	"./Use-heating-pen/filedback.png": 58805,
	"./Use-heating-pen/maxwax.png": 16794,
	"./Use-heating-pen/melt.png": 10899,
	"./Use-heating-pen/melttogether.png": 78635,
	"./Use-heating-pen/multiscraps.png": 15397,
	"./Use-heating-pen/poster.png": 31888,
	"./Use-heating-pen/scraps.png": 83641,
	"./Use-heating-pen/solderingiron.png": 95009,
	"./Use-heating-pen/strings.png": 62570,
	"./Use-heating-pen/thinner.png": 43836,
	"./Use-your-eyes/background.png": 418,
	"./Use-your-eyes/calipers.png": 46034,
	"./Use-your-eyes/calipersrectangle.png": 3934,
	"./Use-your-eyes/flat.png": 12201,
	"./Use-your-eyes/look.png": 30905,
	"./Use-your-eyes/lookback.png": 35430,
	"./Use-your-eyes/lookhere.png": 29775,
	"./Use-your-eyes/nobackground.png": 83858,
	"./Use-your-eyes/poster.png": 47144,
	"./Use-your-eyes/setsquare.png": 99451,
	"./Use-your-eyes/uneven.png": 71718,
	"./alternative-tool-shops/callipers.png": 68190,
	"./alternative-tool-shops/carvers.png": 5781,
	"./alternative-tool-shops/electrics.png": 40264,
	"./alternative-tool-shops/poster.png": 79169,
	"./alternative-tool-shops/saws.png": 4584,
	"./alternative-tool-shops/scalpel.png": 89997,
	"./alternative-tool-shops/tools.png": 18317,
	"./anabel-kawai-onc311-jewelry-design/anabel.png": 94787,
	"./anabel-kawai-onc311-jewelry-design/bulldog.png": 24535,
	"./anabel-kawai-onc311-jewelry-design/cats.png": 63143,
	"./anabel-kawai-onc311-jewelry-design/combining.png": 45659,
	"./anabel-kawai-onc311-jewelry-design/dragon.png": 51498,
	"./anabel-kawai-onc311-jewelry-design/dragonqueen.png": 14890,
	"./anabel-kawai-onc311-jewelry-design/hummingbird.png": 8312,
	"./anabel-kawai-onc311-jewelry-design/morestudio.png": 17540,
	"./anabel-kawai-onc311-jewelry-design/polish.png": 55759,
	"./anabel-kawai-onc311-jewelry-design/poster.png": 21169,
	"./anabel-kawai-onc311-jewelry-design/queen.png": 33162,
	"./anabel-kawai-onc311-jewelry-design/studio.png": 78045,
	"./animal-carving/Mbird.png": 76814,
	"./animal-carving/birb.png": 7297,
	"./animal-carving/birds.png": 37068,
	"./animal-carving/contemplating.png": 56911,
	"./animal-carving/fails.png": 52690,
	"./animal-carving/feathers.png": 30842,
	"./animal-carving/filing.png": 49777,
	"./animal-carving/hold.png": 37506,
	"./animal-carving/poster.png": 53446,
	"./beads/attach.png": 60924,
	"./beads/beads.png": 47230,
	"./beads/caps.png": 54260,
	"./beads/crown.png": 3832,
	"./beads/dipping.png": 60195,
	"./beads/fit.png": 95501,
	"./beads/melting.png": 72469,
	"./beads/opening.png": 3028,
	"./beads/poster.png": 63686,
	"./beads/redo.png": 28594,
	"./beads/size.png": 23325,
	"./blue-wax/blob.png": 49576,
	"./blue-wax/bluefilingdust.png": 12310,
	"./blue-wax/bluepiercingdust.png": 86799,
	"./blue-wax/burredgroove.png": 37368,
	"./blue-wax/filecleanedfrombluedust.png": 26181,
	"./blue-wax/filedblob.png": 44752,
	"./blue-wax/filewithbluedust.png": 69418,
	"./blue-wax/filewithlittlebluedust.png": 93165,
	"./blue-wax/granulationring.png": 38951,
	"./blue-wax/markedwax.png": 76249,
	"./blue-wax/markedwaxwithdust.png": 61928,
	"./blue-wax/needlefilewithbluewax.png": 73662,
	"./blue-wax/needlefilewithlittlebluewax.png": 81042,
	"./blue-wax/needlefilewithoutdust.png": 757,
	"./blue-wax/poster.png": 68288,
	"./blue-wax/remeltedwax.png": 11009,
	"./blue-wax/stanleyknife.png": 12318,
	"./blue-wax/stanleyknifemark.png": 96549,
	"./blue-wax/swirlpendantandring.png": 57385,
	"./blue-wax/swirlpendantfront.png": 88694,
	"./burring-wax/accuracy.png": 46548,
	"./burring-wax/burred.png": 13105,
	"./burring-wax/burrs.png": 47734,
	"./burring-wax/here.png": 77743,
	"./burring-wax/manually.png": 51277,
	"./burring-wax/never.png": 71200,
	"./burring-wax/nocorner.png": 65425,
	"./burring-wax/poster.png": 14156,
	"./burring-wax/rounded.png": 66802,
	"./burring-wax/square.png": 1823,
	"./burring-wax/start.png": 78965,
	"./burring-wax/support.png": 26111,
	"./burring-wax/there.png": 34569,
	"./burring-wax/this.png": 77455,
	"./burring-wax/touching.png": 14522,
	"./burring-wax/waxburr.png": 45418,
	"./can-I-make-it/icecream.png": 70417,
	"./can-I-make-it/poster.png": 46168,
	"./do-not-give-up/birds.png": 47262,
	"./do-not-give-up/poster.png": 88578,
	"./fake-plastic-love/bench.png": 56370,
	"./fake-plastic-love/benchbottom.png": 47083,
	"./fake-plastic-love/benchtop.png": 94499,
	"./fake-plastic-love/desk.png": 5818,
	"./fake-plastic-love/differenttips.png": 13363,
	"./fake-plastic-love/dinnerforone.png": 4066,
	"./fake-plastic-love/drawer.png": 62431,
	"./fake-plastic-love/handsworking.png": 26066,
	"./fake-plastic-love/harecloset.png": 83423,
	"./fake-plastic-love/hinge.png": 54601,
	"./fake-plastic-love/nailtools.png": 7590,
	"./fake-plastic-love/playdough.png": 51950,
	"./fake-plastic-love/poster.png": 83481,
	"./fake-plastic-love/solderingiron.png": 60062,
	"./fake-plastic-love/test.jpg": 22889,
	"./filing-improvers/angle.png": 75120,
	"./filing-improvers/bombe.png": 99429,
	"./filing-improvers/filing.png": 9583,
	"./filing-improvers/flat.png": 72861,
	"./filing-improvers/poster.png": 56037,
	"./filing-improvers/rough.png": 19921,
	"./filing-improvers/smooth.png": 34407,
	"./filing-improvers/unsteady.png": 1076,
	"./gemstone-not-fitting/flatwalls.png": 95447,
	"./gemstone-not-fitting/inside.png": 10417,
	"./gemstone-not-fitting/justright.png": 26776,
	"./gemstone-not-fitting/narrow.png": 22365,
	"./gemstone-not-fitting/poster.png": 75017,
	"./gemstone-not-fitting/pushout.png": 754,
	"./gemstone-not-fitting/roundwalls.png": 65300,
	"./gemstone-not-fitting/slidein.png": 57209,
	"./gemstone-not-fitting/squarein.png": 30173,
	"./gemstone-not-fitting/squarestick.png": 47043,
	"./gemstone-not-fitting/stickingin.png": 31290,
	"./gemstone-not-fitting/stickingout.png": 29295,
	"./gemstone-not-fitting/talcum.png": 43183,
	"./gemstone-not-fitting/talcumbezel.png": 18217,
	"./gemstone-not-fitting/toomuch.png": 94122,
	"./gemstone-not-fitting/upsidedown.png": 92678,
	"./gemstone-not-fitting/wide.png": 9162,
	"./get-started-with-red-moldawax/break.png": 24551,
	"./get-started-with-red-moldawax/dipped.png": 65231,
	"./get-started-with-red-moldawax/flowers.png": 66938,
	"./get-started-with-red-moldawax/form.png": 44974,
	"./get-started-with-red-moldawax/melt.png": 87999,
	"./get-started-with-red-moldawax/melted.png": 86559,
	"./get-started-with-red-moldawax/palmprint.png": 30766,
	"./get-started-with-red-moldawax/pan.png": 21986,
	"./get-started-with-red-moldawax/peel.png": 4832,
	"./get-started-with-red-moldawax/physalis.png": 7846,
	"./get-started-with-red-moldawax/physalisdipped.png": 53670,
	"./get-started-with-red-moldawax/poster.png": 2728,
	"./get-started-with-red-moldawax/pour.png": 27825,
	"./get-started-with-red-moldawax/push.png": 4329,
	"./get-started-with-red-moldawax/red.png": 97247,
	"./get-started-with-red-moldawax/ring.png": 99352,
	"./get-started-with-red-moldawax/talcum.png": 66168,
	"./get-started-with-red-moldawax/wokkel.png": 18604,
	"./get-started-with-sheet-wax/experiments.png": 73833,
	"./get-started-with-sheet-wax/fingernail.png": 29935,
	"./get-started-with-sheet-wax/hook.png": 17471,
	"./get-started-with-sheet-wax/melting.png": 60913,
	"./get-started-with-sheet-wax/poster.png": 18370,
	"./get-started-with-sheet-wax/scissors.png": 4515,
	"./get-started-with-sheet-wax/sheet.png": 80615,
	"./get-started-with-sheet-wax/table.png": 25087,
	"./get-started-with-sheet-wax/worksurface.png": 93918,
	"./get-started-with-wax-wire/break.png": 33040,
	"./get-started-with-wax-wire/close.png": 31596,
	"./get-started-with-wax-wire/heart.png": 14463,
	"./get-started-with-wax-wire/kink.png": 43303,
	"./get-started-with-wax-wire/knot.png": 60339,
	"./get-started-with-wax-wire/knotbreak.png": 99377,
	"./get-started-with-wax-wire/melting.png": 97007,
	"./get-started-with-wax-wire/poster.png": 60320,
	"./get-started-with-wax-wire/preround.png": 80393,
	"./get-started-with-wax-wire/push.png": 3683,
	"./get-started-with-wax-wire/rounded.png": 41826,
	"./get-started-with-wax-wire/twistbreak.png": 28466,
	"./get-started-with-wax-wire/wire.png": 83838,
	"./gold-wax/burredgrooves.png": 27230,
	"./gold-wax/filedblob.png": 49776,
	"./gold-wax/filewithgolddust.png": 16326,
	"./gold-wax/flowerpendantback.png": 49334,
	"./gold-wax/goldfilingdust.png": 7796,
	"./gold-wax/goldflowerpendant.png": 82733,
	"./gold-wax/goldpiercingdust.png": 46676,
	"./gold-wax/markedwax.png": 48200,
	"./gold-wax/needlefilewithdust.png": 55157,
	"./gold-wax/needlwfilewithoutdust.png": 41052,
	"./gold-wax/pendantandring.png": 42677,
	"./gold-wax/poster.png": 50538,
	"./gold-wax/remeltedwax.png": 61267,
	"./gold-wax/ringwithblob.png": 44623,
	"./gold-wax/stanleyknife.png": 55178,
	"./gold-wax/stanleyknifemark.png": 88863,
	"./gold-wax/stringywaxblobs.png": 42125,
	"./green-wax/70.png": 33317,
	"./green-wax/73.png": 77587,
	"./green-wax/airbubbles.png": 44830,
	"./green-wax/coarserwaxdust.png": 33482,
	"./green-wax/finewaxdust.png": 62354,
	"./green-wax/fixblob.png": 84784,
	"./green-wax/fixfiled.png": 81001,
	"./green-wax/flowermarks.png": 16729,
	"./green-wax/pendantback.png": 75148,
	"./green-wax/pendantfront.png": 64390,
	"./green-wax/piercingdust.png": 80480,
	"./green-wax/poster.png": 34532,
	"./green-wax/remeltedwax.png": 97842,
	"./green-wax/ringandflowerpendant.png": 99354,
	"./green-wax/ringblank.png": 88688,
	"./green-wax/stanleyknife.png": 52528,
	"./how-do-I-make-a-jewellery-bench/2jewellerybenchesnexttoeachother.png": 62113,
	"./how-do-I-make-a-jewellery-bench/filehammock.png": 54638,
	"./how-do-I-make-a-jewellery-bench/howtheskinisattached.png": 1986,
	"./how-do-I-make-a-jewellery-bench/jewellerybenchmadefromdesk.png": 92459,
	"./how-do-I-make-a-jewellery-bench/plierrack.png": 26192,
	"./how-do-I-make-a-jewellery-bench/poster.png": 67561,
	"./how-do-I-make-a-jewellery-bench/topviewofbench.png": 47965,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1breakfastbarbench.png": 77613,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1closetshelfbench.png": 33226,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1collage.png": 18426,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1deskbench.png": 5967,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1kitchencounterbench.png": 554,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1ladderbench.png": 25500,
	"./how-do-I-set-up-a-jewellery-bench-at-home/1stackedbench.png": 76110,
	"./how-do-I-set-up-a-jewellery-bench-at-home/poster.png": 57422,
	"./introduction-to-filing-wax/bigfile.png": 77066,
	"./introduction-to-filing-wax/collage.png": 26320,
	"./introduction-to-filing-wax/filethumb.png": 84020,
	"./introduction-to-filing-wax/index.png": 18307,
	"./introduction-to-filing-wax/marking.png": 16106,
	"./introduction-to-filing-wax/middle.png": 60429,
	"./introduction-to-filing-wax/poster.png": 98146,
	"./introduction-to-filing-wax/regularfile.png": 55971,
	"./introduction-to-filing-wax/ringtube.png": 6771,
	"./introduction-to-filing-wax/settings.png": 2838,
	"./introduction-to-filing-wax/texturering.png": 83613,
	"./introduction-to-filing-wax/thumb.png": 36248,
	"./introduction-to-filing-wax/waxfile.png": 80090,
	"./introduction-to-filing-wax/waxslice.png": 55060,
	"./introduction-to-marking-wax/block.png": 46662,
	"./introduction-to-marking-wax/callipers.png": 41589,
	"./introduction-to-marking-wax/clean.png": 39100,
	"./introduction-to-marking-wax/crooked.png": 71828,
	"./introduction-to-marking-wax/how.png": 68272,
	"./introduction-to-marking-wax/line.png": 76195,
	"./introduction-to-marking-wax/mark.png": 75471,
	"./introduction-to-marking-wax/poster.png": 85970,
	"./introduction-to-marking-wax/quarter.png": 38905,
	"./introduction-to-marking-wax/quarter2.png": 80506,
	"./introduction-to-marking-wax/scribe.png": 64076,
	"./introduction-to-marking-wax/stonesee.png": 34341,
	"./introduction-to-marking-wax/straight.png": 44203,
	"./introduction-to-marking-wax/turn.png": 57244,
	"./introduction-to-piercing-wax/25.png": 47800,
	"./introduction-to-piercing-wax/angled.png": 94311,
	"./introduction-to-piercing-wax/corner.png": 13393,
	"./introduction-to-piercing-wax/cornerincrease.png": 18368,
	"./introduction-to-piercing-wax/cutoffs.png": 57040,
	"./introduction-to-piercing-wax/flip.png": 34166,
	"./introduction-to-piercing-wax/guide.png": 17900,
	"./introduction-to-piercing-wax/offcuts.png": 8642,
	"./introduction-to-piercing-wax/piercingangle.png": 62822,
	"./introduction-to-piercing-wax/poster.png": 66633,
	"./introduction-to-piercing-wax/push.png": 49062,
	"./introduction-to-piercing-wax/regularblade.png": 34104,
	"./introduction-to-piercing-wax/regulargap.png": 9176,
	"./introduction-to-piercing-wax/skipblade.png": 38289,
	"./introduction-to-piercing-wax/skipgap.png": 6435,
	"./introduction-to-piercing-wax/spiralblade.png": 72018,
	"./introduction-to-piercing-wax/spiralgap.png": 83626,
	"./just-start/castings.png": 96173,
	"./just-start/experiment.png": 45445,
	"./just-start/poster.png": 51989,
	"./just-start/start.png": 69985,
	"./just-start/tools.png": 5351,
	"./learn-a-classic-bombe-ring/dome.png": 24100,
	"./learn-a-classic-bombe-ring/offcentre.png": 7978,
	"./learn-a-classic-bombe-ring/poster.png": 56871,
	"./learn-a-classic-bombe-ring/rope.png": 31307,
	"./learn-a-classic-bombe-ring/taper.png": 65277,
	"./learn-a-classic-bombe-ring/uneven.png": 30610,
	"./learn-a-classic-bombe-ring/weight.png": 13936,
	"./learn-the-basics-stacking-rings/comfortfit.png": 87725,
	"./learn-the-basics-stacking-rings/filing.png": 33883,
	"./learn-the-basics-stacking-rings/looking.png": 65435,
	"./learn-the-basics-stacking-rings/measuring.png": 37407,
	"./learn-the-basics-stacking-rings/piercing.png": 49015,
	"./learn-the-basics-stacking-rings/poster.png": 5234,
	"./learn-the-basics-stacking-rings/profiles.png": 39619,
	"./learn-the-basics-stacking-rings/sizing.png": 87909,
	"./learn-the-basics-stacking-rings/stackingrings.png": 86462,
	"./leave-fix-redo/collection.png": 2474,
	"./leave-fix-redo/icecream.png": 25673,
	"./leave-fix-redo/poster.png": 37541,
	"./leave-fix-redo/ring.png": 94174,
	"./make-rosecut-ring/badhabit.png": 13406,
	"./make-rosecut-ring/burring.png": 96324,
	"./make-rosecut-ring/courtring.png": 94826,
	"./make-rosecut-ring/damage.png": 25752,
	"./make-rosecut-ring/diagonal.png": 48291,
	"./make-rosecut-ring/horizontal.png": 10921,
	"./make-rosecut-ring/outline.png": 5752,
	"./make-rosecut-ring/outline2.png": 88531,
	"./make-rosecut-ring/outsidesettingwall.png": 73380,
	"./make-rosecut-ring/poster.png": 12290,
	"./make-rosecut-ring/rings.png": 35057,
	"./make-rosecut-ring/ringtube.png": 49281,
	"./make-rosecut-ring/settingwall.png": 13670,
	"./make-rosecut-ring/splitshank.png": 370,
	"./make-rosecut-ring/squarering.png": 78523,
	"./make-rosecut-ring/vertical.png": 45061,
	"./making-variations/3cutouts.png": 99893,
	"./making-variations/allbends.png": 72265,
	"./making-variations/bead.png": 95298,
	"./making-variations/crushed.png": 34320,
	"./making-variations/cutout.png": 55249,
	"./making-variations/flowers.png": 87524,
	"./making-variations/intertwined.png": 40474,
	"./making-variations/layerdoublebend.png": 42738,
	"./making-variations/layersinglebend.png": 80544,
	"./making-variations/poster.png": 67893,
	"./making-variations/preparation.png": 91128,
	"./making-variations/singlestone.png": 13894,
	"./making-variations/stones.png": 20254,
	"./making-variations/triplelayer.png": 2060,
	"./making-variations/up.png": 40373,
	"./making-variations/updownbig.png": 83016,
	"./making-variations/updownsmall.png": 27309,
	"./melting-wax-pieces-together/adding.png": 6396,
	"./melting-wax-pieces-together/blueonpink.png": 53585,
	"./melting-wax-pieces-together/low.png": 97874,
	"./melting-wax-pieces-together/meltone.png": 4635,
	"./melting-wax-pieces-together/melttogether.png": 98174,
	"./melting-wax-pieces-together/meltydip.png": 43815,
	"./melting-wax-pieces-together/meltyraise.png": 22672,
	"./melting-wax-pieces-together/onjoin.png": 58495,
	"./melting-wax-pieces-together/patcheze.png": 90593,
	"./melting-wax-pieces-together/pinkonblue.png": 63107,
	"./melting-wax-pieces-together/poster.png": 10050,
	"./melting-wax-pieces-together/solder.png": 66479,
	"./melting-wax-pieces-together/together.png": 73034,
	"./misc-casting-questions/misc.png": 99193,
	"./misc-casting-questions/poster.png": 33360,
	"./misc-casting-questions/sheet.png": 88971,
	"./misc-casting-questions/superglue.png": 12692,
	"./most-asked-casting-questions/casting.png": 48792,
	"./most-asked-casting-questions/dublin.png": 73787,
	"./most-asked-casting-questions/img.png": 35524,
	"./most-asked-casting-questions/mix.png": 41877,
	"./most-asked-casting-questions/poster.png": 99036,
	"./most-asked-casting-questions/sprue.png": 65837,
	"./most-asked-casting-questions/vienna.png": 36300,
	"./natalie-ho/bench.png": 32050,
	"./natalie-ho/bonsai-tree-wax.png": 10617,
	"./natalie-ho/chinese-bird-and-flower-art.png": 64335,
	"./natalie-ho/koi-fish-wax.png": 27908,
	"./natalie-ho/natalie-bench.png": 63116,
	"./natalie-ho/peony-wax.png": 59032,
	"./natalie-ho/persimmon-tree-pendant-gold.png": 65053,
	"./natalie-ho/persimmon-tree-pendant-wax.png": 33745,
	"./natalie-ho/plum-ring-gold.png": 20718,
	"./natalie-ho/plum-ring-wax.png": 38389,
	"./natalie-ho/poster.png": 32460,
	"./natalie-ho/scalpel-and-heating-pen.png": 83343,
	"./natalie-ho/songbird-stroll-ring.png": 96309,
	"./orange-wax/blob.png": 49309,
	"./orange-wax/burrededge.png": 69495,
	"./orange-wax/filecleanedfromorangedust.png": 44023,
	"./orange-wax/filedblob.png": 96649,
	"./orange-wax/filewithorangedust.png": 37718,
	"./orange-wax/granulation.png": 97881,
	"./orange-wax/markedwax.png": 42039,
	"./orange-wax/markedwaxdifficult.png": 71916,
	"./orange-wax/markedwaxwithdust.png": 1032,
	"./orange-wax/needlefilewithorangewax.png": 94621,
	"./orange-wax/needlefilewithoutdust.png": 83375,
	"./orange-wax/orangefilingdust.png": 67451,
	"./orange-wax/orangepiercingdust.png": 74337,
	"./orange-wax/poster.png": 78070,
	"./orange-wax/remeltedwax.png": 83739,
	"./orange-wax/snowflakependantandring.png": 70437,
	"./orange-wax/snowflakependantback.png": 61544,
	"./orange-wax/stanleyknife.png": 46833,
	"./orange-wax/stanleyknifecrumble.png": 30820,
	"./protect-your-wax/angle.png": 17638,
	"./protect-your-wax/bandaid.png": 79111,
	"./protect-your-wax/broken.png": 81501,
	"./protect-your-wax/chuck.png": 47204,
	"./protect-your-wax/flame.png": 60628,
	"./protect-your-wax/guide.png": 33983,
	"./protect-your-wax/melt.png": 22649,
	"./protect-your-wax/oops.png": 25355,
	"./protect-your-wax/padding.png": 84714,
	"./protect-your-wax/poster.png": 90425,
	"./protect-your-wax/saw.png": 96092,
	"./protect-your-wax/sharp.png": 44997,
	"./protect-your-wax/stape.png": 18843,
	"./protect-your-wax/tape.png": 60298,
	"./protect-your-wax/upsidedown.png": 24909,
	"./purple-wax/airbubbles.png": 66519,
	"./purple-wax/blobfiled.png": 69020,
	"./purple-wax/blobwax.png": 29313,
	"./purple-wax/burring.png": 51650,
	"./purple-wax/courtshape.png": 50470,
	"./purple-wax/filewithdust.png": 68682,
	"./purple-wax/granulationstrings.png": 35576,
	"./purple-wax/markshade.png": 19927,
	"./purple-wax/marksun.png": 57642,
	"./purple-wax/needlefile.png": 96490,
	"./purple-wax/needlefiledig.png": 40700,
	"./purple-wax/poster.png": 37650,
	"./purple-wax/ringandpendant.png": 37201,
	"./purple-wax/stanleyknife.png": 39612,
	"./purple-wax/stanleyknifemark.png": 69771,
	"./purple-wax/waxfilingdust.png": 30917,
	"./purple-wax/waxpiercingdust.png": 51744,
	"./remelting-wax/airbubbles.png": 54957,
	"./remelting-wax/candlewax.png": 97646,
	"./remelting-wax/cooling.png": 99042,
	"./remelting-wax/cup.png": 8359,
	"./remelting-wax/flamingo.png": 17260,
	"./remelting-wax/free.png": 79123,
	"./remelting-wax/icecube.png": 27433,
	"./remelting-wax/melted.png": 87678,
	"./remelting-wax/melty.png": 10944,
	"./remelting-wax/mug.png": 11812,
	"./remelting-wax/open.png": 60661,
	"./remelting-wax/polymermould.png": 90727,
	"./remelting-wax/poster.png": 18099,
	"./remelting-wax/posterbig.png": 94403,
	"./remelting-wax/pour.png": 46226,
	"./remelting-wax/push.png": 4004,
	"./remelting-wax/resinring.png": 75706,
	"./remelting-wax/ringpour.png": 37801,
	"./remelting-wax/ringpours.png": 42936,
	"./remelting-wax/scraps.png": 20857,
	"./remelting-wax/slices.png": 97263,
	"./remelting-wax/solid.png": 32396,
	"./remelting-wax/spoon.png": 63748,
	"./remelting-wax/tealight.png": 53399,
	"./remelting-wax/terrible.png": 14355,
	"./remelting-wax/waxseal.png": 31409,
	"./robot/123.png": 96509,
	"./robot/drill.png": 49240,
	"./robot/hinge.png": 96154,
	"./robot/move.png": 96638,
	"./robot/poster.png": 54138,
	"./robot/robot.png": 72170,
	"./robot/sames.png": 7911,
	"./robot/shapes.png": 58449,
	"./sheet-and-wire/braiding.png": 16328,
	"./sheet-and-wire/braids.png": 38319,
	"./sheet-and-wire/embossing.png": 59034,
	"./sheet-and-wire/etched.png": 76731,
	"./sheet-and-wire/fingernails.png": 73436,
	"./sheet-and-wire/flowers.png": 13377,
	"./sheet-and-wire/folds.png": 6559,
	"./sheet-and-wire/pieces.png": 70840,
	"./sheet-and-wire/poster.png": 44278,
	"./sheet-and-wire/rollers.png": 32101,
	"./sheet-and-wire/scissors.png": 6984,
	"./sheet-and-wire/squares.png": 96830,
	"./sheet-and-wire/variations.png": 1650,
	"./sheet-and-wire/waves.png": 69358,
	"./shrinkage-in-lost-wax-casting/poster.png": 62600,
	"./shrinkage-in-lost-wax-casting/silverringwithdifferentmeaurements.png": 86260,
	"./shrinkage-in-lost-wax-casting/silversettingwithdifferentmeasurements.png": 80669,
	"./shrinkage-in-lost-wax-casting/waxandsilverringonringstick.png": 85428,
	"./shrinkage-in-lost-wax-casting/waxringandcastringonhand.png": 24347,
	"./shrinkage-in-lost-wax-casting/waxringandsilverringonringstick.png": 11980,
	"./shrinkage-in-lost-wax-casting/waxringwithdifferentmeaurements.png": 80810,
	"./shrinkage-in-lost-wax-casting/waxsettingandsilversetting.png": 55042,
	"./shrinkage-in-lost-wax-casting/waxsettingwithdifferentmeasurements.png": 76295,
	"./soft-wax-bezel-settings/allsettings.png": 51613,
	"./soft-wax-bezel-settings/backplate.png": 86269,
	"./soft-wax-bezel-settings/buildup.png": 21729,
	"./soft-wax-bezel-settings/buildupring.png": 49934,
	"./soft-wax-bezel-settings/checkheight.png": 72673,
	"./soft-wax-bezel-settings/chrysoprase.png": 2462,
	"./soft-wax-bezel-settings/decorativeedge.png": 24263,
	"./soft-wax-bezel-settings/fitcheck.png": 24151,
	"./soft-wax-bezel-settings/gap.png": 53907,
	"./soft-wax-bezel-settings/melttogether.png": 82830,
	"./soft-wax-bezel-settings/poster.png": 44813,
	"./soft-wax-bezel-settings/rectangularwire.png": 23174,
	"./soft-wax-bezel-settings/redwax.png": 99203,
	"./soft-wax-bezel-settings/scraps.png": 23699,
	"./soft-wax-bezel-settings/settingwall.png": 43685,
	"./soft-wax-bezel-settings/shapewire.png": 54584,
	"./soft-wax-bezel-settings/sheetbezel.png": 17772,
	"./soft-wax-bezel-settings/sheetstrip.png": 58736,
	"./soft-wax-bezel-settings/volume.png": 81371,
	"./support-your-wax/barrier.png": 34972,
	"./support-your-wax/birb.png": 96718,
	"./support-your-wax/bubblewrap.png": 56013,
	"./support-your-wax/burr.png": 99047,
	"./support-your-wax/carving.png": 19216,
	"./support-your-wax/flex.png": 4115,
	"./support-your-wax/flexing.png": 32775,
	"./support-your-wax/leatherette.png": 34133,
	"./support-your-wax/peg.png": 65242,
	"./support-your-wax/poster.png": 90458,
	"./support-your-wax/protect.png": 3625,
	"./support-your-wax/ring.png": 42922,
	"./support-your-wax/sunburst.png": 99303,
	"./swivel-rings/blank.png": 99413,
	"./swivel-rings/drill.png": 21860,
	"./swivel-rings/egg.png": 14239,
	"./swivel-rings/fits.png": 5998,
	"./swivel-rings/frame.png": 94332,
	"./swivel-rings/invisible.png": 4353,
	"./swivel-rings/pendant.png": 64423,
	"./swivel-rings/poster.png": 76142,
	"./swivel-rings/posts.png": 80374,
	"./swivel-rings/rectangle.png": 4665,
	"./swivel-rings/rings.png": 328,
	"./swivel-rings/stuck.png": 68603,
	"./texturing-sheet-wax/badgerbalm.png": 26183,
	"./texturing-sheet-wax/cutsecond.png": 22861,
	"./texturing-sheet-wax/doubled.png": 32274,
	"./texturing-sheet-wax/dust.png": 38276,
	"./texturing-sheet-wax/leaves.png": 54681,
	"./texturing-sheet-wax/pastaroller.png": 68244,
	"./texturing-sheet-wax/plate.png": 40573,
	"./texturing-sheet-wax/poster.png": 97146,
	"./texturing-sheet-wax/rollingpin.png": 53708,
	"./texturing-sheet-wax/separating.png": 32302,
	"./texturing-sheet-wax/stuck.png": 85304,
	"./texturing-sheet-wax/textures.png": 99566,
	"./trying-out-ideas/allrings.png": 20611,
	"./trying-out-ideas/braid.png": 4623,
	"./trying-out-ideas/bunch.png": 47744,
	"./trying-out-ideas/doodle.png": 6115,
	"./trying-out-ideas/eyes.png": 7875,
	"./trying-out-ideas/firstbatch.png": 15715,
	"./trying-out-ideas/fold.png": 74120,
	"./trying-out-ideas/loop.png": 43324,
	"./trying-out-ideas/love.png": 1212,
	"./trying-out-ideas/poster.png": 51339,
	"./trying-out-ideas/potential.png": 22873,
	"./trying-out-ideas/prepared.png": 17894,
	"./trying-out-ideas/rings.png": 40348,
	"./trying-out-ideas/scrap.png": 80818,
	"./trying-out-ideas/secondbatch.png": 47239,
	"./trying-out-ideas/thirdbatch.png": 10515,
	"./trying-out-ideas/twist.png": 69297,
	"./trying-out-ideas/twister.png": 19963,
	"./turquoise-wax/blobfiled.png": 55336,
	"./turquoise-wax/blobofwax.png": 85813,
	"./turquoise-wax/burredpetals.png": 70547,
	"./turquoise-wax/cleanneedlefile.png": 11452,
	"./turquoise-wax/clearlines.png": 21791,
	"./turquoise-wax/cloggedneedlefile.png": 12448,
	"./turquoise-wax/digmarks.png": 35384,
	"./turquoise-wax/faintmarks.png": 44398,
	"./turquoise-wax/filewithwaxdust.png": 44361,
	"./turquoise-wax/fineturquoisewaxdust.png": 44038,
	"./turquoise-wax/flowerpendantandropering.png": 51285,
	"./turquoise-wax/pendantback.png": 53609,
	"./turquoise-wax/poster.png": 90142,
	"./turquoise-wax/remeltedwax.png": 3297,
	"./turquoise-wax/semicloggedneedlefile.png": 81107,
	"./turquoise-wax/stanleyknife.png": 96280,
	"./turquoise-wax/turquoisewaxdust.png": 62908,
	"./unconventional-tools-kitchen/blades.png": 94498,
	"./unconventional-tools-kitchen/bubbles.png": 21904,
	"./unconventional-tools-kitchen/embossing.png": 31144,
	"./unconventional-tools-kitchen/imprint.png": 96583,
	"./unconventional-tools-kitchen/inaction.png": 774,
	"./unconventional-tools-kitchen/mold.png": 20839,
	"./unconventional-tools-kitchen/oven.png": 32286,
	"./unconventional-tools-kitchen/pastaroller.png": 44779,
	"./unconventional-tools-kitchen/plate.png": 55903,
	"./unconventional-tools-kitchen/poster.png": 90532,
	"./unconventional-tools-kitchen/rollingpin.png": 72700,
	"./unconventional-tools-kitchen/scissors.png": 56640,
	"./unconventional-tools-kitchen/sealmelt.png": 53711,
	"./unconventional-tools-kitchen/sheettexture.png": 50685,
	"./unconventional-tools-kitchen/stove.png": 13733,
	"./unconventional-tools-kitchen/texturepaper.png": 41001,
	"./using-calipers-on-wax/back.png": 6335,
	"./using-calipers-on-wax/calipers.png": 90557,
	"./using-calipers-on-wax/depth.png": 77498,
	"./using-calipers-on-wax/diameter.png": 56408,
	"./using-calipers-on-wax/distance.png": 86628,
	"./using-calipers-on-wax/focus.png": 53680,
	"./using-calipers-on-wax/lock.png": 79923,
	"./using-calipers-on-wax/marking.png": 28321,
	"./using-calipers-on-wax/parallel.png": 71651,
	"./using-calipers-on-wax/poster.png": 65272,
	"./using-calipers-on-wax/symmetrical.png": 20342,
	"./using-pens-on-wax/almost.png": 35623,
	"./using-pens-on-wax/corner.png": 67212,
	"./using-pens-on-wax/file.png": 31118,
	"./using-pens-on-wax/fit.png": 55870,
	"./using-pens-on-wax/flower.png": 7717,
	"./using-pens-on-wax/height.png": 46082,
	"./using-pens-on-wax/low.png": 48264,
	"./using-pens-on-wax/meet.png": 31213,
	"./using-pens-on-wax/pen.png": 56660,
	"./using-pens-on-wax/poster.png": 55820,
	"./using-pens-on-wax/push.png": 43596,
	"./using-pens-on-wax/touch.png": 26356,
	"./using-pens-on-wax/turtle.png": 76555,
	"./using-set-square-on-wax/90.png": 85484,
	"./using-set-square-on-wax/checkcurve.png": 40664,
	"./using-set-square-on-wax/checkflat.png": 9478,
	"./using-set-square-on-wax/checkgap.png": 45942,
	"./using-set-square-on-wax/checknotflat.png": 32585,
	"./using-set-square-on-wax/corner.png": 10772,
	"./using-set-square-on-wax/flat.png": 53850,
	"./using-set-square-on-wax/mark.png": 39421,
	"./using-set-square-on-wax/measure.png": 21040,
	"./using-set-square-on-wax/minigap.png": 97929,
	"./using-set-square-on-wax/nogap.png": 95161,
	"./using-set-square-on-wax/perfect.png": 73838,
	"./using-set-square-on-wax/perfect90.png": 15583,
	"./using-set-square-on-wax/perfectring.png": 66363,
	"./using-set-square-on-wax/poster.png": 73827,
	"./using-set-square-on-wax/setsquare.png": 45813,
	"./using-set-square-on-wax/unperfect90.png": 2613,
	"./using-set-square-on-wax/unperfectring.png": 52669,
	"./using-stanley-knife-on-wax/V.png": 44491,
	"./using-stanley-knife-on-wax/bad.png": 58527,
	"./using-stanley-knife-on-wax/biggap.png": 13178,
	"./using-stanley-knife-on-wax/blade.png": 77806,
	"./using-stanley-knife-on-wax/corner.png": 21020,
	"./using-stanley-knife-on-wax/crumble.png": 30913,
	"./using-stanley-knife-on-wax/down.png": 52834,
	"./using-stanley-knife-on-wax/gap.png": 23668,
	"./using-stanley-knife-on-wax/knife.png": 10559,
	"./using-stanley-knife-on-wax/poster.png": 64108,
	"./using-stanley-knife-on-wax/up.png": 33351,
	"./wax-or-metal/charm.png": 46287,
	"./wax-or-metal/metalwax.png": 29760,
	"./wax-or-metal/poster.png": 27842,
	"./wax-or-metal/signet.png": 94866,
	"./what-ring-tube-should-I-get/2flatsidedringtubes.png": 33763,
	"./what-ring-tube-should-I-get/4ringtubes.png": 75200,
	"./what-ring-tube-should-I-get/flatsidedringtube.png": 81552,
	"./what-ring-tube-should-I-get/linktree size.png": 76921,
	"./what-ring-tube-should-I-get/offcentreringtube.png": 89172,
	"./what-ring-tube-should-I-get/poster.png": 19930,
	"./what-ring-tube-should-I-get/roundringtube.png": 78779,
	"./what-ring-tube-should-I-get/solidringtube.png": 18262,
	"./what-tools-do-I-need-for-wax-carving/23.png": 21161,
	"./what-tools-do-I-need-for-wax-carving/carvingtools.png": 16353,
	"./what-tools-do-I-need-for-wax-carving/files.png": 85221,
	"./what-tools-do-I-need-for-wax-carving/measuringandmarkingtools.png": 32637,
	"./what-tools-do-I-need-for-wax-carving/micromotor.png": 83345,
	"./what-tools-do-I-need-for-wax-carving/poster.png": 29921,
	"./what-tools-do-I-need-for-wax-carving/ringsticks.png": 13314,
	"./what-tools-do-I-need-for-wax-carving/sawandsawblades.png": 73012,
	"./what-tools-do-I-need-for-wax-carving/scale.png": 91954,
	"./what-tools-do-I-need-for-wax-carving/scalpel.png": 50781,
	"./what-tools-do-I-need-for-wax-carving/scalpelblade.png": 84576,
	"./what-tools-do-I-need-for-wax-carving/usbsolderingiron.png": 5233,
	"./what-tools-do-I-need-for-wax-carving/waxcarvingtools.png": 76204,
	"./what-wax-color-should-I-get/Piercing.png": 63430,
	"./what-wax-color-should-I-get/allpendants.png": 25798,
	"./what-wax-color-should-I-get/burring.png": 23263,
	"./what-wax-color-should-I-get/carvingtools.png": 77228,
	"./what-wax-color-should-I-get/gold.png": 6517,
	"./what-wax-color-should-I-get/granulation.png": 87891,
	"./what-wax-color-should-I-get/handfile.png": 75259,
	"./what-wax-color-should-I-get/marking.png": 50166,
	"./what-wax-color-should-I-get/needlefile.png": 38353,
	"./what-wax-color-should-I-get/poster.png": 5519,
	"./what-wax-color-should-I-get/stanleyknife.png": 10345,
	"./why-does-this-happen-in-casting/castings.png": 58847,
	"./why-does-this-happen-in-casting/granule.png": 58682,
	"./why-does-this-happen-in-casting/porosity.png": 59721,
	"./why-does-this-happen-in-casting/poster.png": 67996,
	"./wolf-gold-wax/burredwave.png": 71469,
	"./wolf-gold-wax/filecleanedfromgolddust.png": 18462,
	"./wolf-gold-wax/filedblob.png": 64700,
	"./wolf-gold-wax/filemark.png": 59833,
	"./wolf-gold-wax/filewithgolddust.png": 10230,
	"./wolf-gold-wax/flowerpendantandring.png": 85201,
	"./wolf-gold-wax/flowerpendantfront.png": 41397,
	"./wolf-gold-wax/goldfilingdust.png": 74407,
	"./wolf-gold-wax/goldflowerpendantback.png": 44617,
	"./wolf-gold-wax/goldpiercingdust.png": 86246,
	"./wolf-gold-wax/granulation.png": 80175,
	"./wolf-gold-wax/markedwax.png": 49511,
	"./wolf-gold-wax/needlefilewithdust.png": 14647,
	"./wolf-gold-wax/poster.png": 30261,
	"./wolf-gold-wax/remeltedwax.png": 49422,
	"./wolf-gold-wax/ringwithblob.png": 91751,
	"./wolf-gold-wax/stanleyknife.png": 56593,
	"./wolf-gold-wax/stanleyknifemark.png": 80860,
	"./wolf-gold-wax/stringywaxblobs.png": 32961,
	"./work-in-quarters/bottom.png": 18277,
	"./work-in-quarters/covered.png": 80522,
	"./work-in-quarters/dividersangled.png": 22529,
	"./work-in-quarters/dividersstraight.png": 22096,
	"./work-in-quarters/fileeasy.png": 76774,
	"./work-in-quarters/fileextreme.png": 54515,
	"./work-in-quarters/filehard.png": 73081,
	"./work-in-quarters/hold.png": 61524,
	"./work-in-quarters/left.png": 66093,
	"./work-in-quarters/poster.png": 46800,
	"./work-in-quarters/quarter1.png": 83635,
	"./work-in-quarters/quarter2.png": 19973,
	"./work-in-quarters/quarter34.png": 37140,
	"./work-in-quarters/quarters.png": 82280,
	"./work-in-quarters/right.png": 30770,
	"./work-in-quarters/slipping.png": 58338,
	"./work-in-quarters/top.png": 28900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81652;